<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Edit User</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Form -->
            <div class="form-group mb-3">
              <label for="full-name">Name</label>
              <input
                class="form-control"
                type="text"
                v-model="profile.user.name"
              />
            </div>

            <div class="form-group mb-3">
              <label for="full-name">Position</label>
              <input
                class="form-control"
                type="text"
                v-model="profile.position"
              />
            </div>

            <div class="form-group mb-3">
              <label for="active">Status</label>
              <select class="form-control" v-model="profile.user.active">
                <option value="1">Active</option>
                <option value="0">Not Active</option>
              </select>
            </div>

            <div class="form-group mb-3">
              <label for="role">Role</label>
              <br />
              <!-- <p v-for = "(roled, index) in profile.user.roles" v-bind:key = "index">
                <span>{{roled.name}}</span>
              </p> -->
              <div class="form-check">
                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="2" /> TBA
                  Staff &nbsp; &nbsp; &nbsp;
                </label>
                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="3" /> TBK
                  Staff &nbsp; &nbsp; &nbsp;
                </label>

                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="4" />
                  Administrator &nbsp; &nbsp; &nbsp;
                </label>

                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="5" />
                  Marketing &nbsp; &nbsp; &nbsp;
                </label>

                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="6" /> Finance
                  &nbsp; &nbsp; &nbsp;
                </label>

                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="7" /> General
                  &nbsp; &nbsp; &nbsp;
                </label>

                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="8" checked />
                  Claim &nbsp; &nbsp; &nbsp;
                </label>

                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selected" value="9" /> Call
                  Centre &nbsp; &nbsp; &nbsp;
                </label>
              </div>
            </div>

            <!-- <div class="form-group mb-3">
              <label for="role">Role</label>
              <select class="form-control" >
                <option value = "2">Staff</option>
                <option value = "3">Admin</option>
                <option value = "4">Marketing</option>
                <option value = "5">Finance</option>
                <option value = "6">TBA General</option>
                <option value = "7">TBA Claim</option>
                <option value = "8">TBA Call Centre</option>
              </select>
            </div> -->

            <div class="form-group mb-3">
              <label for="email">Email</label>
              <input
                class="form-control"
                type="email"
                v-model="profile.user.email"
                disabled
              />
            </div>

            <div class="form-group mb-3">
              <label for="username">Username</label>
              <input
                class="form-control"
                type="text"
                v-model="profile.user.username"
              />
            </div>

            <!-- Button -->
            <div class="text-center">
              <button
                @click="update_staff()"
                class="btn btn-rounded btn-primary"
                style="width: 100px"
              >
                Update
              </button>
            </div>

            <hr />
            <div class="form-group mb-3">
              <label for="password">New Password</label>
              <input class="form-control" type="password" v-model="password" />
            </div>

            <div class="form-group mb-3">
              <label for="password_confirm">Confirm New Password</label>
              <input
                class="form-control"
                type="hidden"
                v-model="profile.user_id"
              />
              <input
                class="form-control"
                type="password"
                v-model="password_confirmation"
              />
            </div>
            <!-- Button -->
            <div class="text-center">
              <button
                @click="update_password"
                class="btn btn-rounded btn-primary"
                style="width: 150px"
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "edit_staff",
  components: {},
  update: [],

  data() {
    return {
      selected: [],
      user_id: "",
      password: "",
      password_confirmation: "",
      roles: [],
      profile: {
        user: {
          name: "",
          email: "",
          role: [],
          active: "",
          username: "",
        },
        position: "",
      },
    };
  },

  computed: {},

  methods: {
    get_roles() {
      let roles = this.profile.user.roles;
      let roles_array = [];

      roles.forEach((role) => {
        roles_array.push(role.id);
      });
      this.selected = roles_array;
    },
    loadProfile() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/staffs/" + this.id, {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            if (!res.data.id) {
              swal({
                text: res.data.message,
                icon: "error",
                button: "OK",
              }).then(() => {
                this.$router.push("/login");
                localStorage.clear();
              });
            }

            this.profile = res.data;
            this.get_roles();
          });
      }
    },

    update_staff() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (confirm) {
            axios
              .post(
                "/staffs/update/" + this.id,
                {
                  name: this.profile.user.name,
                  position: this.profile.position,
                  active: this.profile.user.active,
                  role: this.selected,
                  username: this.profile.user.username,
                  _method: "PATCH",
                },
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((res) => {
                if (res.data.success) {
                  swal({
                    icon: "success",
                    text: res.data.message,
                  });
                } else {
                  swal({
                    icon: "warning",
                    text: res.data.message,
                  });
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled",
            });
          }
        });
      }
    },

    update_password() {
      let token = localStorage.getItem("token");
      let id = this.profile.user_id;

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (confirm) {
            axios
              .post(
                "staffs/edit_password/" + id,
                {
                  password: this.password,
                  password_confirmation: this.password_confirmation,
                  _method: "PATCH",
                },
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((res) => {
                if(!res.data.success) {
                  return swal({
                    icon: "error",
                    text: res.data.message,
                  });
                }
                return swal({
                  icon: "success",
                  text: "Successful!",
                });
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled",
            });
          }
        });
      }
    },
  },

  mounted() {
    this.loadProfile();
  },
};
</script>
